/**
 * Query client used for handling app state, refetching data, etc
 */
import { QueryClient } from '@tanstack/react-query'

export default new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },

    mutations: {
      retry: false,
    },
  },
})
